export default "/static/dashboard/build/app/img/v2/4f646c7adc9766635f369c4962653383.png";